// import { normalize, schema } from 'normalizr';
import * as types from '../../constants/subscriptionSearch';
import * as searchActions from '../../constants/searchActions';
import * as dotProp from 'dot-prop-immutable';
import dotPropCombine from '../../util/dotProp';
import { SET_SEARCH_TYPE } from '../../constants/ordersSearchActionTypes';
import { SHOW_TOOLS } from 'actions/types';

/**
 * @typedef {object} SubscriptionModel
 * @property {string|null} cancellation_reason
 * @property {string|null} cancellation_reason_comments
 * @property {string|null} cancelled_at
 * @property {string|null} charge_interval_frequency
 * @property {string|null} expire_after_specific_number_of_charges
 * @property {string|null} order_interval_frequency
 * @property {string|null} order_interval_unit
 * @property {string} created_at
 * @property {string} updated_at
 * @property {string} next_charge_scheduled_at
 * @property {string} product_title
 * @property {string} sku
 * @property {string} variant_title
 * @property {string} status
 * @property {number} id
 * @property {number} price
 * @property {number} shopify_product_id
 * @property {number} shopify_variant_id
 * @property {number} quantity
 * @property {number} address_id
 * @property {number} customer_id
 * @property {number} has_queued_charges
 * @property {number} max_retries_reached
 * @property {number|null} order_day_of_month
 * @property {number|null} order_day_of_week
 * @property {array} properties
 * @property {string} properties[].name
 * @property {string} properties[].value
 */
// const subscription = new schema.Entity('subscriptions');

/**
 * @typedef {object} SubscriptionSearchState
 * @property {SubscriptionModel[]} subscriptions
 * @property {string|null} selectedTask
 * @property {string|null} shopContext
 * @property {string} subscriptionSystem
 * @property {SubscriptionModel} selectedSubscription
 */

const unselectedSubscriptionState = {
  selectedSubscription: {}, // used in search subs view
  selectedSubscriptionIds: [], // decision tree only
};

const initialState = {
  subscriptions: [],
  selectedTask: null,
  subscriptionSystem: 'simplrOrder',
  shopContext: null,
  selectedSubscriptionForConfirmationPage: null,
  searchParams: {
    searchValue: null,
    searchType: searchActions.SIMPLR_ORDER_SUBSCRIPTION_EMAIL,
  },
  ...unselectedSubscriptionState,
  // subscriptionEntities: {},
};

/**
 * @return SubscriptionSearchState
 */
function subscriptionSearchReducer(state = initialState, action) {
  switch (action.type) {
    case types.SET_SUBSCRIPTION_SEARCH:
      return { ...initialState, ...action.data };
    case types.SET_SUBSCRIPTION_SYSTEM:
      return dotProp.set(state, 'subscriptionSystem', action.subscriptionSystem);
    case types.SET_SUBSCRIPTIONS:
      return dotProp.set(state, 'subscriptions', action.subscriptions);
    case types.SELECT_SUBSCRIPTION:
      // update the selected subscription
      state = dotProp.set(state, 'selectedSubscription', action.subscription);
      // find the matching sub in our list and update it with the new value
      const subId = action.subscription && action.subscription.id;
      const indexOfSub = state.subscriptions.findIndex((sub) => sub.id === subId);
      if (indexOfSub > -1) {
        return dotProp.set(state, `subscriptions.${indexOfSub}`, action.subscription);
      }

      return state;

    case types.SET_SELECTED_SUBSCRIPTION_FOR_CONFIRMATION_PAGE:
      return dotProp.set(
        state,
        'selectedSubscriptionForConfirmationPage',
        action.selectedSubscriptionForConfirmationPage
      );
    case types.SELECT_SUBSCRIPTION_TASK:
      return dotProp.set(state, 'selectedTask', action.selectedTask);
    case types.SET_SEARCH_VALUE:
      return dotProp.set(state, 'searchParams.searchValue', action.searchValue);
    case types.SET_SEARCH_TYPE:
      // reset the search value when the search type changes
      return dotProp.merge(state, 'searchParams', {
        searchType: action.searchType,
        searchValue: null,
      });
    // return dotProp.set(state, 'searchParams.searchType', action.searchType);
    case types.SET_SHOP_CONTEXT:
      return dotProp.set(state, 'shopContext', action.shopContext);

    case SET_SEARCH_TYPE:
      // reset the selected subscription if changing the search type
      return dotPropCombine(state, unselectedSubscriptionState);

    case SHOW_TOOLS:
      return {
        ...initialState,
      };

    // decision tree actions
    case types.SELECT_SUBSCRIPTION_IN_DECISION_TREE:
      const selectedSubscriptionIds = [...state.selectedSubscriptionIds, action.subscriptionId];

      return dotProp.set(state, 'selectedSubscriptionIds', selectedSubscriptionIds);
    case types.UNSELECT_SUBSCRIPTION_IN_DECISION_TREE: {
      // eslint-disable-next-line
      const selectedSubscriptionIds = state.selectedSubscriptionIds.filter((id) => id !== action.subscriptionId);

      return dotProp.set(state, 'selectedSubscriptionIds', selectedSubscriptionIds);
    }
    case types.UNSELECT_ALL_SUBSCRIPTIONS_IN_DECISION_TREE:
      return dotProp.set(state, 'selectedSubscriptionIds', []);

    case types.UPDATE_SUBSCRIPTION: {
      // find the matching sub in our list and update it with the new value
      // eslint-disable-next-line
      const subId = action.subscription.id;
      // eslint-disable-next-line
      const indexOfSub = state.subscriptions.findIndex((sub) => sub.id === subId);
      // should always exist in list but if for some reason it doesn't no need to do anythign
      if (indexOfSub > -1) {
        return dotProp.set(state, `subscriptions.${indexOfSub}`, action.subscription);
      }

      return state;
    }

    case types.SET_PAUSE_SUBSCRIPTION: {
      return {
        ...state,
        pauseSubscriptionDetails: action.pauseSubscriptionDetails,
      };
    }

    default:
      return state;
  }
}

export default subscriptionSearchReducer;
